import React, { useEffect } from 'react';
import { Subscribe } from 'unstated';
import { RouteComponentProps } from 'react-router';
import OrganizationContainer from '../../../../shared/state/containers/OrganizationContainer';
import ApplicationContainer from '../../../../shared/state/containers/ApplicationContainer';
import TitleStateContainer from '../../../../shared/state/containers/TitleStateContainer';
import AuthContainer from '../../../../shared/state/containers/AuthContainer';
import ReviewDashboardContent from './components/ReviewDashboardContent';
import CurrentApplicationContainer from '../../../../shared/hooks/CurrentApplicationContainer';

interface BasicReviewDashboardProps {
    applicationId: string
}

const BasicReviewDashboard: React.FC<RouteComponentProps<BasicReviewDashboardProps>> = (props) => {
    // Set current application ID in the container
    const currentAppContainer = CurrentApplicationContainer.useContainer();
    useEffect(() => {
        if (props.match.params.applicationId) {
            currentAppContainer.setApplicationId(props.match.params.applicationId);
        }
    }, [props.match.params.applicationId, currentAppContainer]);

    return (
        <Subscribe to={[OrganizationContainer, ApplicationContainer, AuthContainer, TitleStateContainer]}>
            {(
                orgContainer: OrganizationContainer,
                appContainer: ApplicationContainer,
                authContainer: AuthContainer,
                titleContainer: TitleStateContainer
            ) => (
                <ReviewDashboardContent
                    orgsContainer={orgContainer}
                    appContainer={appContainer}
                    authContainer={authContainer}
                    titleContainer={titleContainer}
                    applicationId={props.match.params.applicationId}
                    history={props.history}                />
            )}
        </Subscribe>
    );

}

export default BasicReviewDashboard;